export default __webpack_public_path__ + "static/logo-cloudy-bay-circle-22493cf9c4285a14dd66870b2be41f50.svg";